import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import Dashboard from './pages/Dashboard'
import RegisterUser from './pages/RegisterUser'
import Login from './pages/Login'
import ResponsiveAppBar from './components/AppBar'
import ForgotPass from './pages/ForgotPass'
import { useAuthContext } from './hooks/useAuthContext'
import HomePage from './pages/HomePage'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import InfoGuide from './pages/InfoGuide'
import { lime, purple } from '@mui/material/colors';
import Fees from './pages/Fees'
import CodeofConduct from './pages/CodeofConduct'
import PurchaseCourse from './pages/auth/PurchaseCourse'
import PaymentReturn from './pages/auth/PaymentReturn'
import Terms from './pages/Terms'
import ContactUs from './pages/ContactUs'
function App() {




  const theme = createTheme({
    palette: {
      primary: {
        main: '#2b3a42'

      },
      secondary: {
        main: '#e91e63'
      },
    },

  });

  const { user,
    authIsReady,
    accessLevel,
    parentID
  } = useAuthContext()




  return (
    <>

      {
        authIsReady && (
          <ThemeProvider theme={theme}>

            <BrowserRouter>
              {user && (<ResponsiveAppBar />)}
              <Routes>

                <Route path="/" element={accessLevel ? <PurchaseCourse /> : <HomePage />} />
                <Route path="/purchase" element={accessLevel ? <PurchaseCourse /> : <HomePage />} />
                <Route path="/login" element={accessLevel ? <Navigate to="/" /> : <Login />} />
                <Route path="/forgotpassword" element={accessLevel ? <Navigate to="/" /> : <ForgotPass />} />
                <Route path="/register" element={accessLevel ? <Navigate to="/" /> : <RegisterUser />} />

                <Route path="/info" element={accessLevel ? <Navigate to="/" /> : <InfoGuide />} />
                <Route path="/Fees" element={accessLevel ? <Navigate to="/" /> : <Fees />} />
                <Route path="/conduct" element={<CodeofConduct />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/tnc" element={<Terms />} />
                <Route path="/contact" element={<ContactUs />} />


                <Route path="/paymentreturn/:id" element={user ? <PaymentReturn /> : <Navigate to="/" />} />



              </Routes>
            </BrowserRouter>
          </ThemeProvider>
        )
      }

    </>
  );
}

export default App;
